var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-list" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "客户名称" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入客户名称", clearable: "" },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户电话" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入客户电话", clearable: "" },
                      model: {
                        value: _vm.searchForm.mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "mobile", $$v)
                        },
                        expression: "searchForm.mobile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户地址" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入客户地址", clearable: "" },
                      model: {
                        value: _vm.searchForm.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "address", $$v)
                        },
                        expression: "searchForm.address",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "合同号" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入合同号", clearable: "" },
                      model: {
                        value: _vm.searchForm.contractNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "contractNo", $$v)
                        },
                        expression: "searchForm.contractNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "门店" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入门店", clearable: "" },
                      model: {
                        value: _vm.searchForm.storeName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "storeName", $$v)
                        },
                        expression: "searchForm.storeName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showMoreSearch,
                          expression: "showMoreSearch",
                        },
                      ],
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        width: "100%",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "审计状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.searchForm.isAudit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "isAudit", $$v)
                                },
                                expression: "searchForm.isAudit",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "待审计", value: "1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "已审计", value: "2" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入订单号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.productionOrder,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "productionOrder", $$v)
                              },
                              expression: "searchForm.productionOrder",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "全部", clearable: "" },
                              on: { change: _vm.handleSearchClick },
                              model: {
                                value: _vm.searchForm.productionStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "productionStatus",
                                    $$v
                                  )
                                },
                                expression: "searchForm.productionStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" },
                              }),
                              _vm._v(" "),
                              _vm._l(
                                _vm.dict.order_status_button,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "合同状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.searchForm.contractStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "contractStatus",
                                    $$v
                                  )
                                },
                                expression: "searchForm.contractStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" },
                              }),
                              _vm._v(" "),
                              _vm._l(
                                _vm.dict.contract_status_button,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "导购" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { placeholder: "请输入导购", clearable: "" },
                            model: {
                              value: _vm.searchForm.guideNickName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "guideNickName", $$v)
                              },
                              expression: "searchForm.guideNickName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "设计师" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入设计师",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.designerNickName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm,
                                  "designerNickName",
                                  $$v
                                )
                              },
                              expression: "searchForm.designerNickName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              type: "daterange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.createDateRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "createDateRange", $$v)
                              },
                              expression: "searchForm.createDateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "下单时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              type: "daterange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.orderClerkTimeRange,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm,
                                  "orderClerkTimeRange",
                                  $$v
                                )
                              },
                              expression: "searchForm.orderClerkTimeRange",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "search-btn-item" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            _vm.showMoreSearch = !_vm.showMoreSearch
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.showMoreSearch ? "收起" : "展开") +
                            "\n            "
                        ),
                        _c("i", {
                          class: _vm.showMoreSearch
                            ? "el-icon-arrow-up"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.searchLoading },
                        on: { click: _vm.handleSearchClick },
                      },
                      [
                        _c("i", { staticClass: "el-icon-search" }),
                        _vm._v(" 搜索\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      { attrs: { plain: "" }, on: { click: _vm.resetSearch } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divider-line" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "status-tabs" },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-wrap": "wrap",
                  flex: "1",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    class: [
                      "status-button",
                      { selected: _vm.selectedStatus === "全部" },
                    ],
                    attrs: {
                      type:
                        _vm.selectedStatus === "全部" ? "primary" : "default",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleStatusClick("全部")
                      },
                    },
                  },
                  [
                    _vm._v("\n          全部\n          "),
                    (_vm.statusCounts && _vm.statusCounts.total) > 0
                      ? _c("span", { staticClass: "status-badge" }, [
                          _vm._v(
                            _vm._s(
                              (_vm.statusCounts && _vm.statusCounts.total) || 0
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.dict.contract_status_button, function (item) {
                  return _c(
                    "el-button",
                    {
                      key: item.id,
                      class: [
                        "status-button",
                        { selected: _vm.selectedStatus === item.value },
                      ],
                      attrs: {
                        type:
                          _vm.selectedStatus === item.value
                            ? _vm.getTagType(item.value)
                            : "default",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleStatusClick(item.value)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(item.label) + "\n          "
                      ),
                      _vm.getStatusCount(item.label) > 0
                        ? _c("span", { staticClass: "status-badge" }, [
                            _vm._v(_vm._s(_vm.getStatusCount(item.label) || 0)),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.$parent.checkPer(["admin", "orders:batchQuote"])
              ? _c(
                  "el-button",
                  {
                    staticStyle: { "font-size": "14px" },
                    attrs: { type: "text", icon: "el-icon-money" },
                    on: { click: _vm.handleBatchPaySimple },
                  },
                  [_vm._v("批量确认报价")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "text",
                  size: "small",
                  icon: _vm.isAllExpanded
                    ? "el-icon-arrow-up"
                    : "el-icon-arrow-down",
                },
                on: { click: _vm.handleToggleExpand },
              },
              [_vm._v(_vm._s(_vm.isAllExpanded ? "全部折叠" : "全部展开"))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "font-size": "14px" },
                attrs: { type: "text", icon: "el-icon-setting" },
                on: { click: _vm.openConfigDialog },
              },
              [_vm._v("配置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "font-size": "14px" },
                attrs: { type: "text", icon: "el-icon-download" },
                on: { click: _vm.openExportDialog },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.showExportDialog,
                  title: "导出字段选择",
                  width: "520px",
                  "append-to-body": "",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.showExportDialog = $event
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "max-height": "360px",
                      overflow: "auto",
                      padding: "10px",
                    },
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.toggleExportSelectAll },
                        model: {
                          value: _vm.exportSelectAll,
                          callback: function ($$v) {
                            _vm.exportSelectAll = $$v
                          },
                          expression: "exportSelectAll",
                        },
                      },
                      [_vm._v("全选")]
                    ),
                    _vm._v(" "),
                    _c("el-divider"),
                    _vm._v(" "),
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.exportSelectedFields,
                          callback: function ($$v) {
                            _vm.exportSelectedFields = $$v
                          },
                          expression: "exportSelectedFields",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                            },
                          },
                          _vm._l(_vm.tableHeader, function (col) {
                            return _c(
                              "el-checkbox",
                              {
                                key: col.key,
                                staticStyle: { width: "50%", padding: "6px 0" },
                                attrs: { label: col.key },
                              },
                              [_vm._v(_vm._s(col.label))]
                            )
                          }),
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showExportDialog = false
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmExport },
                      },
                      [_vm._v("导出")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.searchLoading,
                    expression: "searchLoading",
                  },
                ],
                attrs: {
                  "element-loading-text": "正在加载合同数据...",
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(255, 255, 255, 0.8)",
                },
              },
              [
                _c(
                  "el-table",
                  {
                    ref: "contractTable",
                    staticStyle: {
                      width: "100%",
                      "margin-bottom": "20px",
                      "font-size": "16px",
                    },
                    attrs: {
                      data: _vm.contractList,
                      "max-height": _vm.tableHeight,
                      "header-cell-style": {
                        backgroundColor: "#e8eaed",
                        color: "#333",
                        fontWeight: "bold",
                      },
                      "cell-style": { paddingBottom: "8px", paddingTop: "8px" },
                      border: "",
                      "row-key": "id",
                      type: "expand",
                    },
                    on: { "row-click": _vm.handleRowClick },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "expand" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.cmsCustDesignSchemeAuditList &&
                              scope.row.cmsCustDesignSchemeAuditList.length > 0
                                ? _c(
                                    "div",
                                    { staticStyle: { "margin-left": "20px" } },
                                    [
                                      _c(
                                        "el-table",
                                        {
                                          staticStyle: {
                                            width: "calc(100% - 20px)",
                                            "font-size": "13px",
                                          },
                                          attrs: {
                                            data: scope.row
                                              .cmsCustDesignSchemeAuditList,
                                            size: "small",
                                            "header-cell-style": {
                                              backgroundColor: "#e8eaed",
                                              color: "#333",
                                              fontWeight: "bold",
                                            },
                                            "cell-style": {
                                              backgroundColor: "#FFF",
                                            },
                                            border: "",
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "操作",
                                              width: "180",
                                              fixed: "left",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [
                                                      _c("input", {
                                                        staticStyle: {
                                                          "margin-right": "8px",
                                                        },
                                                        attrs: {
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.checkedOrders.includes(
                                                              row.row.rowId
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          },
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleOrderCheck(
                                                              row.row.rowId,
                                                              $event.target
                                                                .checked
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            color: "#409EFF",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleViewOrder(
                                                                row.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("查看")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.$parent.checkPer([
                                                        "admin",
                                                        "orders:orderOperation",
                                                      ])
                                                        ? _c(
                                                            "el-dropdown",
                                                            {
                                                              attrs: {
                                                                trigger:
                                                                  "click",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "14px",
                                                                    color:
                                                                      "#1890ff",
                                                                  },
                                                                  attrs: {
                                                                    size: "mini",
                                                                    type: "text",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            更多 "
                                                                  ),
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-arrow-down",
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-dropdown-menu",
                                                                [
                                                                  _c(
                                                                    "el-dropdown-item",
                                                                    {
                                                                      nativeOn:
                                                                        {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleRollbackOrder(
                                                                                row.row
                                                                              )
                                                                            },
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "回退"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  row.row
                                                                    .productionStatus ===
                                                                    "待经销商确认" &&
                                                                  _vm.$parent.checkPer(
                                                                    [
                                                                      "admin",
                                                                      "contract:pay",
                                                                    ]
                                                                  )
                                                                    ? _c(
                                                                        "el-dropdown-item",
                                                                        {
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handlePayOrder(
                                                                                    row.row
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "付款"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  row.row
                                                                    .productionStatus !==
                                                                  "未提交"
                                                                    ? _c(
                                                                        "el-dropdown-item",
                                                                        {
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleCancelOrder(
                                                                                    row.row
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "取消"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "productionOrder",
                                              label: "销售单号",
                                              width: "140",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "auditName",
                                              label: "产品名称",
                                              width: "200",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "订单状态",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "order-status",
                                                          class: {
                                                            "o-status-pending":
                                                              row.row
                                                                .productionStatus ===
                                                              "未提交",
                                                            "o-status-submitted":
                                                              row.row
                                                                .productionStatus ===
                                                              "已提交",
                                                            "o-status-unknown":
                                                              ![
                                                                "未提交",
                                                                "已提交",
                                                              ].includes(
                                                                row.row
                                                                  .productionStatus
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.row
                                                                .productionStatus
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "酷家乐状态",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.row.auditStatus ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "创建人",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.row
                                                            .createUserName ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "创建时间",
                                              width: "160",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.row.createTime ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "特殊申请",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [_vm._v("-")]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "拆单人",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.row.approvedBy ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "拆单时间",
                                              width: "160",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (row) {
                                                    return [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.row
                                                            .approvedDate || "-"
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#909399",
                                        "text-align": "center",
                                        padding: "20px",
                                      },
                                    },
                                    [_vm._v("暂无订单")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "320", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              _c(
                                "div",
                                { staticClass: "contract-actions" },
                                [
                                  _c("input", {
                                    staticStyle: { "margin-right": "8px" },
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: _vm.checkedContracts.includes(
                                        row.row.id
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      change: function ($event) {
                                        return _vm.handleContractCheck(
                                          row.row.id,
                                          $event.target.checked
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#606266" },
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleCreateOrder(row.row)
                                        },
                                      },
                                    },
                                    [_vm._v("下单")]
                                  ),
                                  _vm._v(" "),
                                  _vm.$parent.checkPer([
                                    "contract:syncContractStatus",
                                  ])
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#606266" },
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleSyncContract(
                                                row.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("同步")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown",
                                    {
                                      attrs: { trigger: "click" },
                                      on: {
                                        command: function (command) {
                                          return _vm.handleContractBatchCommand(
                                            command,
                                            row.row
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "dropdown",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-dropdown-menu",
                                                  [
                                                    _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: "download",
                                                          disabled:
                                                            !!_vm.downloadingContractId,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.downloadingContractId ===
                                                                row.row.id
                                                                ? "下载中..."
                                                                : "批量下载"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.$parent.checkPer([
                                                      "admin",
                                                      "orders:batchOperation",
                                                    ])
                                                      ? _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command: "urgent",
                                                            },
                                                          },
                                                          [_vm._v("加急")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.$parent.checkPer([
                                                      "admin",
                                                      "orders:batchOperation",
                                                    ]) &&
                                                    _vm.$parent.checkPer([
                                                      "admin",
                                                      "contract:pay",
                                                    ])
                                                      ? _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command: "pay",
                                                            },
                                                          },
                                                          [_vm._v("批量付款")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.$parent.checkPer([
                                                      "admin",
                                                      "orders:batchOperation",
                                                    ])
                                                      ? _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command:
                                                                "rollback",
                                                            },
                                                          },
                                                          [_vm._v("批量回退")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.$parent.checkPer([
                                                      "admin",
                                                      "orders:batchOperation",
                                                    ])
                                                      ? _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command: "cancel",
                                                            },
                                                          },
                                                          [_vm._v("批量取消")]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#606266" },
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v("\n                  更多 "),
                                          _c("i", {
                                            staticClass: "el-icon-arrow-down",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.tableHeader, function (col) {
                      return _vm.isColumnVisible(col.key)
                        ? _c("el-table-column", {
                            key: col.key,
                            attrs: {
                              prop: col.key,
                              "min-width": _vm.getColumnWidth(col.key),
                              label: col.label,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      col.key === "customerStats"
                                        ? _c("span", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-tag el-tag--info el-tag--mini el-tag--light",
                                              },
                                              [
                                                _vm._v(
                                                  "合同 " +
                                                    _vm._s(
                                                      scope.row.contractNum || 0
                                                    ) +
                                                    " 个"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-tag el-tag--primary el-tag--mini el-tag--light",
                                              },
                                              [
                                                _vm._v(
                                                  "订单 " +
                                                    _vm._s(
                                                      scope.row.orderNum || 0
                                                    ) +
                                                    " 个"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-tag el-tag--success el-tag--mini el-tag--light",
                                              },
                                              [
                                                _vm._v(
                                                  "售后 " +
                                                    _vm._s(
                                                      scope.row.afterNum || 0
                                                    ) +
                                                    " 个"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  "el-tag",
                                                  _vm.getCustomerStatusClass(
                                                    scope.row.custStatus
                                                  ),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.custStatus ||
                                                      "未知"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ])
                                        : col.key === "contractImgs"
                                        ? _c("span", [
                                            scope.row.contractImgs
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "file-count",
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.previewContractImgs(
                                                          scope.row.contractImgs
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#409EFF",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.parseContractImgs(
                                                              scope.row
                                                                .contractImgs
                                                            ).length
                                                          ) + " 张"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("-")]),
                                          ])
                                        : col.key === "file"
                                        ? _c("span", [
                                            scope.row.file
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "file-count",
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.previewContractFiles(
                                                          scope.row.file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#409EFF",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.parseContractFiles(
                                                              scope.row.file
                                                            ).length
                                                          ) + " 个"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("-")]),
                                          ])
                                        : col.key === "contractNo"
                                        ? _c("span", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "contract-link",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleColumnContractClick(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getColumnValue(
                                                      col.key,
                                                      scope.row
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getColumnValue(
                                                  col.key,
                                                  scope.row
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showUrgentApplyDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUrgentApplyDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.urgentApplyForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "contractNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          合同号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入合同号", disabled: "" },
                    model: {
                      value: _vm.urgentApplyForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "contractNo", $$v)
                      },
                      expression: "urgentApplyForm.contractNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custName" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户名称\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户名称", disabled: "" },
                    model: {
                      value: _vm.urgentApplyForm.custName,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "custName", $$v)
                      },
                      expression: "urgentApplyForm.custName",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custAddress" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户地址\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户地址", disabled: "" },
                    model: {
                      value: _vm.urgentApplyForm.custAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "custAddress", $$v)
                      },
                      expression: "urgentApplyForm.custAddress",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "applyDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择申请日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.urgentApplyForm.applyDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "applyDate", $$v)
                      },
                      expression: "urgentApplyForm.applyDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "applyReason" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请原因\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "4",
                      placeholder: "请输入申请原因",
                    },
                    model: {
                      value: _vm.urgentApplyForm.applyReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "applyReason", $$v)
                      },
                      expression: "urgentApplyForm.applyReason",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "remark" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          备注\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "2",
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.urgentApplyForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.urgentApplyForm, "remark", $$v)
                      },
                      expression: "urgentApplyForm.remark",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 附件\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("CommonUpload", {
                        ref: "urgentApplyFileUpload",
                        attrs: { strict: true },
                        on: {
                          uploadSuccess: _vm.handleFileUpload,
                          delSuccess: _vm.handleFileDelete,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showUrgentApplyDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveUrgentApply },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showOrderDetailDialog,
            width: "800px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showOrderDetailDialog = $event
            },
          },
        },
        [
          _vm.currentOrder
            ? _c("OrderDetail", { attrs: { order: _vm.currentOrder } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showBatchPayDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showBatchPayDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.batchPayForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "orderNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          销售单号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入销售单号", disabled: "" },
                    model: {
                      value: _vm.batchPayForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchPayForm, "orderNo", $$v)
                      },
                      expression: "batchPayForm.orderNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "contractNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          合同号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入合同号", disabled: "" },
                    model: {
                      value: _vm.batchPayForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchPayForm, "contractNo", $$v)
                      },
                      expression: "batchPayForm.contractNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custName" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          客户名称\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户名称", disabled: "" },
                    model: {
                      value: _vm.batchPayForm.custName,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchPayForm, "custName", $$v)
                      },
                      expression: "batchPayForm.custName",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custAddress" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          客户地址\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户地址", disabled: "" },
                    model: {
                      value: _vm.batchPayForm.custAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchPayForm, "custAddress", $$v)
                      },
                      expression: "batchPayForm.custAddress",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "payReason" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 付款事由\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择付款事由" },
                      model: {
                        value: _vm.batchPayForm.payReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchPayForm, "payReason", $$v)
                        },
                        expression: "batchPayForm.payReason",
                      },
                    },
                    _vm._l(
                      _vm.dict.order_payment_reason.filter(function (i) {
                        return i.unit === "true"
                      }),
                      function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "totalAmount" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 总金额\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请输入总金额",
                      min: 0,
                      precision: 2,
                    },
                    model: {
                      value: _vm.batchPayForm.totalAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchPayForm, "totalAmount", $$v)
                      },
                      expression: "batchPayForm.totalAmount",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "receivingAccount" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 收款账户\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择收款账户",
                        "popper-class": "multi-line-select",
                      },
                      model: {
                        value: _vm.batchPayForm.receivingAccount,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchPayForm, "receivingAccount", $$v)
                        },
                        expression: "batchPayForm.receivingAccount",
                      },
                    },
                    _vm._l(
                      _vm.dict.order_receiving_account.filter(function (i) {
                        return i.unit === "true"
                      }),
                      function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.id,
                            attrs: { label: item.label, value: item.value },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "multi-line-option" },
                              _vm._l(
                                item.label.split("|"),
                                function (sub, index) {
                                  return _c(
                                    "span",
                                    { key: index, staticClass: "option-line" },
                                    [_vm._v(_vm._s(sub.trim()))]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }
                    ),
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "remark" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          备注\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入备注",
                      rows: "2",
                    },
                    model: {
                      value: _vm.batchPayForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchPayForm, "remark", $$v)
                      },
                      expression: "batchPayForm.remark",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 附件\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("CommonUpload", {
                        ref: "batchPayFileUpload",
                        attrs: { strict: true },
                        on: {
                          uploadSuccess: _vm.handleBatchPayFileUpload,
                          delSuccess: _vm.handleBatchPayFileDelete,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.batchPaySubmitting },
                  on: {
                    click: function ($event) {
                      _vm.showBatchPayDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.batchPaySubmitting },
                  on: { click: _vm.saveBatchPay },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showPayDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPayDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.payForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "orderNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          销售单号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入销售单号", disabled: "" },
                    model: {
                      value: _vm.payForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.payForm, "orderNo", $$v)
                      },
                      expression: "payForm.orderNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "contractNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          合同号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入合同号", disabled: "" },
                    model: {
                      value: _vm.payForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.payForm, "contractNo", $$v)
                      },
                      expression: "payForm.contractNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custName" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          客户名称\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户名称", disabled: "" },
                    model: {
                      value: _vm.payForm.custName,
                      callback: function ($$v) {
                        _vm.$set(_vm.payForm, "custName", $$v)
                      },
                      expression: "payForm.custName",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custAddress" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          客户地址\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户地址", disabled: "" },
                    model: {
                      value: _vm.payForm.custAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.payForm, "custAddress", $$v)
                      },
                      expression: "payForm.custAddress",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "payReason" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 付款事由\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择付款事由" },
                      model: {
                        value: _vm.payForm.payReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.payForm, "payReason", $$v)
                        },
                        expression: "payForm.payReason",
                      },
                    },
                    _vm._l(
                      _vm.dict.order_payment_reason.filter(function (i) {
                        return i.unit === "true"
                      }),
                      function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "totalAmount" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 总金额\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请输入总金额",
                      min: 0,
                      precision: 2,
                    },
                    model: {
                      value: _vm.payForm.totalAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.payForm, "totalAmount", $$v)
                      },
                      expression: "payForm.totalAmount",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "receivingAccount" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 收款账户\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择收款账户",
                        "popper-class": "multi-line-select",
                      },
                      model: {
                        value: _vm.payForm.receivingAccount,
                        callback: function ($$v) {
                          _vm.$set(_vm.payForm, "receivingAccount", $$v)
                        },
                        expression: "payForm.receivingAccount",
                      },
                    },
                    _vm._l(
                      _vm.dict.order_receiving_account.filter(function (i) {
                        return i.unit === "true"
                      }),
                      function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.id,
                            attrs: { label: item.label, value: item.value },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "multi-line-option" },
                              _vm._l(
                                item.label.split("|"),
                                function (sub, index) {
                                  return _c(
                                    "span",
                                    { key: index, staticClass: "option-line" },
                                    [_vm._v(_vm._s(sub.trim()))]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }
                    ),
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "remark" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          备注\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入备注",
                      rows: "2",
                    },
                    model: {
                      value: _vm.payForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.payForm, "remark", $$v)
                      },
                      expression: "payForm.remark",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 附件\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("CommonUpload", {
                        ref: "payFileUpload",
                        attrs: { strict: true },
                        on: {
                          uploadSuccess: _vm.handlePayFileUpload,
                          delSuccess: _vm.handlePayFileDelete,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.paySubmitting },
                  on: {
                    click: function ($event) {
                      _vm.showPayDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.paySubmitting },
                  on: { click: _vm.savePay },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCancelDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCancelDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.cancelForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "orderNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          销售单号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入销售单号", disabled: "" },
                    model: {
                      value: _vm.cancelForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "orderNo", $$v)
                      },
                      expression: "cancelForm.orderNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "contractNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          合同号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入合同号", disabled: "" },
                    model: {
                      value: _vm.cancelForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "contractNo", $$v)
                      },
                      expression: "cancelForm.contractNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custName" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户名称\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户名称", disabled: "" },
                    model: {
                      value: _vm.cancelForm.custName,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "custName", $$v)
                      },
                      expression: "cancelForm.custName",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custAddress" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户地址\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户地址", disabled: "" },
                    model: {
                      value: _vm.cancelForm.custAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "custAddress", $$v)
                      },
                      expression: "cancelForm.custAddress",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "orderDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 下单日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "date", placeholder: "请选择下单日期" },
                    model: {
                      value: _vm.cancelForm.orderDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "orderDate", $$v)
                      },
                      expression: "cancelForm.orderDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "orderApprovalDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          拆单日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "date", placeholder: "请选择拆单日期" },
                    model: {
                      value: _vm.cancelForm.orderApprovalDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "orderApprovalDate", $$v)
                      },
                      expression: "cancelForm.orderApprovalDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "plannedDeliveryDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          计划交货日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "date", placeholder: "请选择计划交货日期" },
                    model: {
                      value: _vm.cancelForm.plannedDeliveryDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "plannedDeliveryDate", $$v)
                      },
                      expression: "cancelForm.plannedDeliveryDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "applyDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "date", placeholder: "请选择申请日期" },
                    model: {
                      value: _vm.cancelForm.applyDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "applyDate", $$v)
                      },
                      expression: "cancelForm.applyDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "applyReason" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请原因\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入申请原因",
                      rows: "2",
                    },
                    model: {
                      value: _vm.cancelForm.applyReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "applyReason", $$v)
                      },
                      expression: "cancelForm.applyReason",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "urgentAfterReorder" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 取消后重新下单是否需要加急\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.cancelForm.urgentAfterReorder,
                        callback: function ($$v) {
                          _vm.$set(_vm.cancelForm, "urgentAfterReorder", $$v)
                        },
                        expression: "cancelForm.urgentAfterReorder",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "是", value: "是" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "否", value: "否" } }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "remark" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          备注\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入备注",
                      rows: "2",
                    },
                    model: {
                      value: _vm.cancelForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "remark", $$v)
                      },
                      expression: "cancelForm.remark",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "附件" } }, [
                _c(
                  "div",
                  [
                    _c("CommonUpload", {
                      ref: "cancelFileUpload",
                      attrs: { strict: true },
                      on: {
                        uploadSuccess: _vm.handleCancelFileUpload,
                        delSuccess: _vm.handleCancelFileDelete,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCancelDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.cancelSubmitting },
                  on: { click: _vm.saveCancel },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showRollbackDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRollbackDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.rollbackForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "productionOrder" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          销售单号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入销售单号", disabled: "" },
                    model: {
                      value: _vm.rollbackForm.productionOrder,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "productionOrder", $$v)
                      },
                      expression: "rollbackForm.productionOrder",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "contractNo" } },
                [
                  _c("template", { slot: "label" }, [
                    _vm._v("\n          合同编号\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入合同编号", disabled: "" },
                    model: {
                      value: _vm.rollbackForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "contractNo", $$v)
                      },
                      expression: "rollbackForm.contractNo",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custName" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户姓名\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户姓名", disabled: "" },
                    model: {
                      value: _vm.rollbackForm.custName,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "custName", $$v)
                      },
                      expression: "rollbackForm.custName",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "custAddress" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户地址\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入客户地址", disabled: "" },
                    model: {
                      value: _vm.rollbackForm.custAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "custAddress", $$v)
                      },
                      expression: "rollbackForm.custAddress",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "orderDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 下单日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择下单日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.rollbackForm.orderDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "orderDate", $$v)
                      },
                      expression: "rollbackForm.orderDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "orderApprovalDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 拆单通过日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择拆单通过日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.rollbackForm.orderApprovalDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "orderApprovalDate", $$v)
                      },
                      expression: "rollbackForm.orderApprovalDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "plannedDeliveryDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 计划交货日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择计划交货日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.rollbackForm.plannedDeliveryDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "plannedDeliveryDate", $$v)
                      },
                      expression: "rollbackForm.plannedDeliveryDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "applyDate" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请日期\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择申请日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.rollbackForm.applyDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "applyDate", $$v)
                      },
                      expression: "rollbackForm.applyDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "applyReason" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请原因\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "4",
                      placeholder: "请输入申请原因",
                    },
                    model: {
                      value: _vm.rollbackForm.applyReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.rollbackForm, "applyReason", $$v)
                      },
                      expression: "rollbackForm.applyReason",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "附件" } }, [
                _c(
                  "div",
                  [
                    _c("CommonUpload", {
                      ref: "rollbackFileUpload",
                      attrs: { strict: true },
                      on: {
                        uploadSuccess: _vm.handleRollbackFileUpload,
                        delSuccess: _vm.handleRollbackFileDelete,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showRollbackDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveRollback } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.configDialogVisible,
            width: "600px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.configDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                height: "300px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-right": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("可选列")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _vm._l(_vm.tableHeader, function (col) {
                        return !col.visible
                          ? _c(
                              "div",
                              {
                                key: col.key,
                                staticStyle: {
                                  padding: "8px",
                                  "margin-bottom": "8px",
                                  "background-color": "#fff",
                                  border: "1px solid #ebeef5",
                                  "border-radius": "4px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleColumnVisible(col.key)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(col.label) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      !_vm.tableHeader.some(function (col) {
                        return !col.visible
                      })
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无可选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "center",
                    gap: "10px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-right",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return !col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToRight },
                    },
                    [_vm._v("全部右移")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-left",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToLeft },
                    },
                    [_vm._v("全部左移")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-left": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _vm._v("已选列（"),
                      _c("i", {
                        staticClass: "el-icon-rank",
                        staticStyle: { "margin-right": "5px" },
                      }),
                      _vm._v("拖拽排序）"),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                      attrs: { id: "selectedColumnsList" },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticStyle: { "min-height": "100%" },
                          attrs: {
                            options: {
                              animation: 150,
                              ghostClass: "sortable-ghost",
                              handle: ".drag-handle",
                            },
                            element: "div",
                          },
                          model: {
                            value: _vm.visibleColumns,
                            callback: function ($$v) {
                              _vm.visibleColumns = $$v
                            },
                            expression: "visibleColumns",
                          },
                        },
                        _vm._l(_vm.visibleColumns, function (col) {
                          return _c(
                            "div",
                            {
                              key: col.key,
                              staticStyle: {
                                padding: "8px",
                                "margin-bottom": "8px",
                                "background-color": "#f5f7fa",
                                "border-radius": "4px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleColumnVisible(
                                            col.key
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(col.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-rank drag-handle",
                                    staticStyle: {
                                      cursor: "move",
                                      color: "#909399",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.visibleColumns.length === 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无已选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.resetHeaderConfig } }, [
                _vm._v("重置"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveHeaderConfig },
                },
                [_vm._v("保存配置")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAddOrderDialog,
            width: "60%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddOrderDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.addOrderForm, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "问题类型", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入问题类型" },
                    model: {
                      value: _vm.addOrderForm.questionType,
                      callback: function ($$v) {
                        _vm.$set(_vm.addOrderForm, "questionType", $$v)
                      },
                      expression: "addOrderForm.questionType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "客服" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "8px",
                    },
                  },
                  [
                    _vm.addOrderForm.serverNickName
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-right": "2px" },
                            attrs: { type: "success" },
                          },
                          [_vm._v(_vm._s(_vm.addOrderForm.serverNickName))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: { icon: "el-icon-plus" },
                      on: { click: _vm.openAddOrderCustomerSelect },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("CommonUpload", {
                    ref: "addOrderFileUpload",
                    attrs: { strict: true },
                    on: {
                      uploadSuccess: _vm.handleAddOrderFileUpload,
                      delSuccess: _vm.handleAddOrderFileDelete,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图片" } },
                [
                  _c("CommonUpload", {
                    ref: "addOrderImageUpload",
                    attrs: { strict: true },
                    on: {
                      uploadSuccess: _vm.handleAddOrderImageUpload,
                      delSuccess: _vm.handleAddOrderImageDelete,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "视频" } },
                [
                  _c("CommonUpload", {
                    ref: "addOrderVideoUpload",
                    attrs: { strict: true },
                    on: {
                      uploadSuccess: _vm.handleAddOrderVideoUpload,
                      delSuccess: _vm.handleAddOrderVideoDelete,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "问题描述" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "4",
                      placeholder: "请输入问题描述",
                    },
                    model: {
                      value: _vm.addOrderForm.problemDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.addOrderForm, "problemDescription", $$v)
                      },
                      expression: "addOrderForm.problemDescription",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.addOrderForm.bomList && _vm.addOrderForm.bomList.length > 0
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      margin: "10px 0",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("h4", { staticStyle: { margin: "0" } }, [
                      _vm._v("BOM数据"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", icon: "el-icon-refresh" },
                        on: { click: _vm.resetBomSearch },
                      },
                      [_vm._v("清空筛选")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { margin: "10px 0" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.bomTableLoading,
                            expression: "bomTableLoading",
                          },
                        ],
                        ref: "bomTable",
                        staticStyle: { width: "100%", "margin-top": "10px" },
                        attrs: {
                          data: _vm.filteredBomList,
                          border: "",
                          "row-key": "id",
                          "tree-props": {
                            children: "children",
                            hasChildren: "hasChildren",
                          },
                          "highlight-current-row": "",
                          height: _vm.screenHeight * 0.4,
                        },
                        on: {
                          "selection-change": _vm.handleBomSelectionChange,
                          "row-click": _vm.handleBomRowClick,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "55",
                            "reserve-selection": true,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              prop: "barcode",
                              label: "板件编码",
                              width: "180",
                              sortable: "",
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "100%",
                                      "margin-top": "4px",
                                    },
                                    attrs: {
                                      placeholder: "搜索",
                                      clearable: "",
                                      size: "mini",
                                    },
                                    on: { input: _vm.handleBomSearch },
                                    model: {
                                      value: _vm.addOrderForm.searchBarCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.addOrderForm,
                                          "searchBarCode",
                                          $$v
                                        )
                                      },
                                      expression: "addOrderForm.searchBarCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v("\n              板件编码\n            "),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              prop: "code",
                              label: "编码",
                              width: "120",
                              sortable: "",
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "100%",
                                      "margin-top": "4px",
                                    },
                                    attrs: {
                                      placeholder: "搜索",
                                      clearable: "",
                                      size: "mini",
                                    },
                                    on: { input: _vm.handleBomSearch },
                                    model: {
                                      value: _vm.addOrderForm.searchCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.addOrderForm,
                                          "searchCode",
                                          $$v
                                        )
                                      },
                                      expression: "addOrderForm.searchCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v("\n              编码\n            "),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              prop: "name",
                              label: "名称",
                              width: "150",
                              sortable: "",
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "100%",
                                      "margin-top": "4px",
                                    },
                                    attrs: {
                                      placeholder: "搜索",
                                      clearable: "",
                                      size: "mini",
                                    },
                                    on: { input: _vm.handleBomSearch },
                                    model: {
                                      value: _vm.addOrderForm.searchName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.addOrderForm,
                                          "searchName",
                                          $$v
                                        )
                                      },
                                      expression: "addOrderForm.searchName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v("\n              名称\n            "),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "splitTypeName",
                            label: "类型",
                            width: "100",
                            sortable: "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: {
                              prop: "color",
                              label: "颜色",
                              width: "100",
                              sortable: "",
                            },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "100%",
                                      "margin-top": "4px",
                                    },
                                    attrs: {
                                      placeholder: "搜索",
                                      clearable: "",
                                      size: "mini",
                                    },
                                    on: { input: _vm.handleBomSearch },
                                    model: {
                                      value: _vm.addOrderForm.searchColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.addOrderForm,
                                          "searchColor",
                                          $$v
                                        )
                                      },
                                      expression: "addOrderForm.searchColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v("\n              颜色\n            "),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "length",
                            label: "长",
                            width: "80",
                            sortable: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "width",
                            label: "宽",
                            width: "80",
                            sortable: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "height",
                            label: "高",
                            width: "80",
                            sortable: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "quantity",
                            label: "数量",
                            width: "80",
                            sortable: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "remark",
                            label: "备注",
                            width: "120",
                            sortable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    padding: "20px",
                    color: "#999",
                    "min-height": "400px",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.bomTableLoading,
                          expression: "bomTableLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { "element-loading-text": "查询中..." },
                    },
                    [
                      !_vm.bomTableLoading
                        ? _c("span", [_vm._v("暂无BOM数据")])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showAddOrderDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.createReplenishmentOnly } }, [
                _vm._v("创建"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价信息",
            visible: _vm.showQuotationDialog,
            width: "80%",
            top: "20px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showQuotationDialog = $event
            },
          },
        },
        [
          _vm.showQuotationDialog
            ? _c("ContractQuotationInfo", {
                ref: "contractQuotationInfo",
                attrs: { contract: _vm.currentQuotationContract },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "合同详情",
            visible: _vm.showContractViewDialog,
            width: "80%",
            top: "20px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showContractViewDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "contract-basic-info" },
            [
              _c("ContractBasicInfo", {
                attrs: {
                  contract: _vm.currentContract,
                  editable: _vm.contractEditable,
                },
                on: { "preview-image": _vm.previewImage },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contract-view-section" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleContractTabClick },
                  model: {
                    value: _vm.activeContractTab,
                    callback: function ($$v) {
                      _vm.activeContractTab = $$v
                    },
                    expression: "activeContractTab",
                  },
                },
                [
                  _vm.$parent.checkPer(["admin", "contracts:design"])
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "设计信息", name: "design" } },
                        [
                          _c("ContractDesignInfo", {
                            ref: "contractDesignInfo",
                            attrs: {
                              contract: _vm.currentContract,
                              editable: _vm.contractEditable,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "contracts:follow"])
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "跟进信息", name: "follow" } },
                        [
                          _c("ContractFollowInfo", {
                            attrs: {
                              contract: _vm.currentContract,
                              editable: _vm.contractEditable,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "contracts:specialApply"])
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "审批申请", name: "special" } },
                        [
                          _c("ContractSpecialApply", {
                            ref: "specialApply",
                            attrs: {
                              contract: _vm.currentContract,
                              editable: _vm.contractEditable,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "contracts:quotation"])
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "报价信息", name: "quotation" } },
                        [
                          _c("ContractQuotationInfo", {
                            ref: "contractQuotationInfo",
                            attrs: {
                              contract: _vm.currentContract,
                              editable: _vm.contractEditable,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$parent.checkPer([
                    "admin",
                    "contracts:productionTracking",
                  ])
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: "生产跟踪",
                            name: "productionTracking",
                          },
                        },
                        [
                          _c("ContractProductionTracking", {
                            ref: "contractProductionTracking",
                            attrs: {
                              contract: _vm.currentContract,
                              editable: _vm.contractEditable,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "contracts:view"])
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "改补描述", name: "afterInfo" } },
                        [
                          _c("ContractAfterInfo", {
                            ref: "contractAfterInfo",
                            attrs: {
                              contract: _vm.currentContract,
                              editable: _vm.contractEditable,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "图片预览",
            visible: _vm.previewImageVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticClass: "full-image",
            attrs: { src: _vm.previewImageUrl },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "合同图片预览",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
            _vm._l(_vm.previewImages, function (img, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticStyle: {
                    width: "33.33%",
                    padding: "8px",
                    "box-sizing": "border-box",
                    "text-align": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        overflow: "auto",
                        display: "inline-block",
                        "max-width": "100%",
                      },
                    },
                    [
                      _c("el-image", {
                        staticStyle: { width: "100%", height: "280px" },
                        attrs: {
                          src: img.url,
                          alt: img.name,
                          "preview-src-list": _vm.previewImages.map(function (
                            i
                          ) {
                            return i.url
                          }),
                          "initial-index": index,
                          fit: "contain",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center",
                        gap: "8px",
                        "margin-top": "6px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-download",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleDownload(img)
                            },
                          },
                        },
                        [_vm._v("下载")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewFilesVisible,
            title: "合同附件预览",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewFilesVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.previewFiles },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "文件名", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function ($event) {
                                return _vm.openFileInNewWindow(
                                  scope.row.url,
                                  scope.row.realName
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.name))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "url", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openFileInNewWindow(
                                  scope.row.url,
                                  scope.row.realName
                                )
                              },
                            },
                          },
                          [_vm._v("\n            打开\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-download",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleFileDownload(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            下载  \n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showModifyOrderDialog,
            title: "改单",
            width: "700px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showModifyOrderDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.modifyOrderForm, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "问题类型", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入问题类型" },
                    model: {
                      value: _vm.modifyOrderForm.questionType,
                      callback: function ($$v) {
                        _vm.$set(_vm.modifyOrderForm, "questionType", $$v)
                      },
                      expression: "modifyOrderForm.questionType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "客服" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "8px",
                    },
                  },
                  [
                    _vm.modifyOrderForm.serverNickName
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-right": "2px" },
                            attrs: { type: "success" },
                          },
                          [_vm._v(_vm._s(_vm.modifyOrderForm.serverNickName))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: { icon: "el-icon-plus" },
                      on: { click: _vm.openCustomerSelect },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("CommonUpload", {
                    ref: "modifyOrderFileUpload",
                    attrs: { strict: true },
                    on: {
                      uploadSuccess: _vm.handleModifyOrderFileUpload,
                      delSuccess: _vm.handleModifyOrderFileDelete,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图片" } },
                [
                  _c("CommonUpload", {
                    ref: "modifyOrderImageUpload",
                    attrs: { strict: true },
                    on: {
                      uploadSuccess: _vm.handleModifyOrderImageUpload,
                      delSuccess: _vm.handleModifyOrderImageDelete,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "视频" } },
                [
                  _c("CommonUpload", {
                    ref: "modifyOrderVideoUpload",
                    attrs: { strict: true },
                    on: {
                      uploadSuccess: _vm.handleModifyOrderVideoUpload,
                      delSuccess: _vm.handleModifyOrderVideoDelete,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "问题描述" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "4",
                      placeholder: "请输入问题描述",
                    },
                    model: {
                      value: _vm.modifyOrderForm.problemDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.modifyOrderForm, "problemDescription", $$v)
                      },
                      expression: "modifyOrderForm.problemDescription",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showModifyOrderDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.createChangeOnly } }, [
                _vm._v("仅创建"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.createChangeAndOrder },
                },
                [_vm._v("创建并下单")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "customerUserSelect",
        attrs: { "show-user-select": _vm.showCustomerUserSelect },
        on: {
          close: _vm.onCustomerUserSelectClose,
          "select-user-callBack": _vm.selectCustomerCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }